import MultipleAcceptingOrderItemsField from '../components/multiple_accepting_order_items_field'

export default {
  components: { MultipleAcceptingOrderItemsField }
}
